import Box from '@mui/material/Box';

function Bold({ text }) {
    return <Box component="span" sx={{ fontWeight: 'bold' }}> {text}</Box>
}

export default Bold;